var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-crew-settings-box__item" }, [
    _c("div", { staticClass: "c-crew-settings-box__item-ranking" }, [
      !_vm.hideRanking
        ? _c("span", {
            class: "c-ranking c-ranking--" + (_vm.ranking || "transparent"),
            attrs: { title: _vm.rankingMessage },
          })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-crew-settings-box__item-name" },
      [
        _vm._v("\n   " + _vm._s(_vm.vehicle.displayName) + "\n   "),
        _vm.shouldShowCategoryName
          ? [
              _c("span", { staticClass: "u-text-medium" }, [
                _vm._v("\n      – " + _vm._s(_vm.vehicle.category) + "\n    "),
              ]),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }